import React from "react";
import FormSection from "../../components/FormSection";
import brochureImg from "../../images/merkazy_brochure.png";
import sectionMaskGroup from "../../images/Logos.png";
import sectionMaskGroupMobile from "../../images/Logos-3.png";
import MerakzyAdvantagesSection from "../../components/MerakzyAdvantagesSection";
import BlogSection from "../../components/BlogSection";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const handleTutorials = () => {
    navigate(`/tutorials`);
  }

  return (
   <div className="bg-white">
      <section className="text-center pt-24 px-4 md:px-6">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-6xl font-semibold leading-tight mb-6">
            <span className="text-[#0c0407]">Merakzy </span>
            <span className="text-[#c4c4c4]">е новиот регионален</span>
            <span className="text-[#0c0407] block">
              <span className="text-[#c4c4c4]">стандард за</span> туристички агенции
            </span>
          </h1>
          <p className="text-lg md:text-xl text-[#0c0407] max-w-3xl mx-auto mt-4">
            Погледнете како преку еден софтвер можете да ги менаџирате сите <br/> понуди, резервации и цела комуникација со патниците и субагентите.
          </p>
          <button className="mt-8 flex items-center justify-center gap-2 bg-[#fa0053] rounded-[16px] text-white px-6 py-3 mx-auto hover:opacity-90 transition" onClick={handleTutorials}>
            Tуторијали            
          </button>
        </div>
      </section>

      <section className="relative w-full pb-12 px-4 md:px-6">
        <div className="container mx-auto">
          <div className="relative w-full h-[20rem] md:h-[50rem] rounded-3xl overflow-hidden">
            <img
              src={brochureImg}
              alt="Brochure"
              className="w-full h-full object-contain rounded-3xl"
            />
          </div>
        </div>
      </section>

      <section className="pb-16 pt-6 border-b border-gray-200 px-4 md:px-6">
        <div className="container mx-auto">
            <p className="text-black-400 font-bold mb-6 text-center">
            ВЕРЕН ПАРТНЕР НА ПОВЕЌЕ ОД 20 КОМПАНИИ ВО МАКЕДОНИЈА И СРБИЈА
            </p>

            {/* Mobile carousel */}
            <div className="relative w-full h-24 md:hidden overflow-hidden">
            {/* Fade overlay */}
            <div className="pointer-events-none absolute inset-0 z-10 flex">
              <div className="w-16 h-full bg-gradient-to-r from-white"></div>
              <div className="flex-1"></div>
              <div className="w-16 h-full bg-gradient-to-l from-white"></div>
            </div>

            {/* Scrolling images */}
            <div className="flex w-[200%] absolute top-0 left-0 animate-scroll-horizontal">
              <img
                src={sectionMaskGroupMobile}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
              <img
                src={sectionMaskGroupMobile}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
            </div>
          </div>

            {/* Desktop carousel */}
            <div className="relative w-full h-24 hidden md:block overflow-hidden">
            {/* Fade overlay */}
            <div className="pointer-events-none absolute inset-0 z-10 flex">
              <div className="w-16 h-full bg-gradient-to-r from-white"></div>
              <div className="flex-1"></div>
              <div className="w-16 h-full bg-gradient-to-l from-white"></div>
            </div>

            {/* Scrolling images */}
            <div className="flex w-[200%] absolute top-0 left-0 animate-scroll-horizontal">
              <img
                src={sectionMaskGroup}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
              <img
                src={sectionMaskGroup}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
            </div>
          </div>
        </div>
      </section>

      <MerakzyAdvantagesSection/>
      <FormSection />
      <BlogSection />
    </div>
    )
};

export default Home;